import moment from "moment";
import React, { useContext, useState } from "react";

const dateFormat = "MM/DD/YY";

const StartTimeContext = React.createContext();
const EndTimeContext = React.createContext();

export function useStartTime() {
  return useContext(StartTimeContext);
}

export function useEndTime() {
  return useContext(EndTimeContext);
}

export function DateProvider({ children }) {
  const [startTime, setStartTime] = useState(
    moment().subtract(7, "days").format(dateFormat)
  );
  const [endTime, setEndTime] = useState(moment().format(dateFormat));

  return (
    <StartTimeContext.Provider value={{ startTime, setStartTime }}>
      <EndTimeContext.Provider value={{ endTime, setEndTime }}>
        {children}
      </EndTimeContext.Provider>
    </StartTimeContext.Provider>
  );
}
